import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/', { replace: true });
      return;
    }

    const sessionId = match[1];
    const returnTo = localStorage.getItem('auth_return_to') || '/shop';
    localStorage.removeItem('auth_return_to');

    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Auth failed');
        const data = await res.json();
        login({ user_id: data.user_id, email: data.email, name: data.name, is_new: data.is_new });
        // Store discount eligibility for new users
        if (data.is_new) {
          localStorage.setItem('new_user_discount', 'true');
        }
        navigate(returnTo, { replace: true, state: { authComplete: true, isNew: data.is_new } });
      } catch (err) {
        console.error('Auth callback failed:', err);
        navigate(returnTo, { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-white dark:bg-[#0A0A0A] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#00E5FF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-500">Signing you in...</p>
      </div>
    </div>
  );
}
